// RefsContext.js for pdf generation
import React from 'react';

const RefsContext = React.createContext();

export default RefsContext;
